import React from 'react';
import { DesignMode, Editor } from '@mnz/builder';
import { Document, Container, Basic } from '@mnz/element';
import IFrame, { FrameContextConsumer } from 'react-frame-component';
import { StyleSheetManager } from 'styled-components';
import { Account, DesignSettings, Frame, SerializedNodes } from '@mnz/builder';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

interface DesignPreviewProps {
    data: string | SerializedNodes;
    designSettings: DesignSettings;
    account: Account;
}

const DesignPreview: React.FC<DesignPreviewProps> = ({ data, designSettings, account }) => {
    return (
        <Editor resolver={{ Document, Container, ...Basic }} enabled={false} mode={DesignMode.PREVIEW}>
            <IFrame
                initialContent={`<!DOCTYPE html><html><head><style>\n::-webkit-scrollbar{\ndisplay:none;\n}\n-ms-overflow-style:none;\nscrollbar-width:none;\n</style></head><body><div class="frame-root"></div></body></html>`}
                style={{
                    width: '100%',
                    height: '100%',
                }}
            >
                <FrameContextConsumer>
                    {({ document }) => {
                        return (
                            <StyleSheetManager target={document?.head}>
                                <CacheProvider
                                    value={createCache({
                                        key: 'css',
                                        container: document?.head,
                                        prepend: true,
                                    })}
                                >
                                    <Frame
                                        data={data}
                                        config={{
                                            fontEndpoint: process.env.REACT_APP_FONT_PATH as string,
                                        }}
                                        designSettings={{
                                            ...designSettings,
                                            url: `https://${process.env.REACT_APP_LIVE_BIO_DOMAIN}/${account.username}`,
                                        }}
                                        account={account}
                                    ></Frame>
                                </CacheProvider>
                            </StyleSheetManager>
                        );
                    }}
                </FrameContextConsumer>
            </IFrame>
        </Editor>
    );
};

export default DesignPreview;
